import { render, staticRenderFns } from "./TableBuilder.vue?vue&type=template&id=392ac988&scoped=true"
import script from "./TableBuilder.vue?vue&type=script&lang=js"
export * from "./TableBuilder.vue?vue&type=script&lang=js"
import style0 from "./TableBuilder.vue?vue&type=style&index=0&id=392ac988&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392ac988",
  null
  
)

export default component.exports